import Modal from 'react-bootstrap/Modal';

const BdoModal = (props) => {
  const { showModal, setShowModal, serviceAreaTitle, children } = props;

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      size="xl"
      centered
      aria-label={`${serviceAreaTitle} service areas`}
      className={props.classProp}
    >
      <button className="btn-modal-close btn-reset" onClick={() => setShowModal(false)}>
        <span className="material-icons">close</span>
      </button>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default BdoModal;
